export const printExam = () => /* GraphQL */ `
  mutation PrintExam($input: PrintExamInput!) {
    printExam(input: $input) {
      ... on ExportDocumentSuccessResponse {
        __typename
        resultUrl
        packageUrl
      }
      ... on ExportDocumentErrorResponse {
        __typename
        log
        error
        packageUrl
      }
    }
  }
`;

export const printVerificationDocument = () => /* GraphQL */ `
  mutation PrintVerificationDocument($input: PrintVerificationDocumentInput!) {
    printVerificationDocument(input: $input) {
      ... on ExportDocumentSuccessResponse {
        __typename
        resultUrl
        packageUrl
      }
      ... on ExportDocumentErrorResponse {
        __typename
        log
        error
        packageUrl
      }
    }
  }
`;

export const printYearAtAGlanceDocument = () => /* GraphQL */ `
  mutation PrintYearAtAGlance($input: PrintYearAtaGlanceInput!) {
    printYearAtaGlance(input: $input) {
      ... on ExportDocumentSuccessResponse {
        __typename
        resultUrl
        packageUrl
      }
      ... on ExportDocumentErrorResponse {
        __typename
        log
        error
        packageUrl
      }
    }
  }
`;

export const printPerformanceAssessmentDocument = () => /* GraphQL */ `
  mutation PrintPerformanceAssessment(
    $input: PrintPerformanceAssessmentInput!
  ) {
    printPerformanceAssessment(input: $input) {
      ... on ExportDocumentSuccessResponse {
        __typename
        resultUrl
        packageUrl
      }
      ... on ExportDocumentErrorResponse {
        __typename
        log
        error
        packageUrl
      }
    }
  }
`;
